import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newCustomer() {
    let customerDetails = {
      customer_name: $(".customer_name").val(),
      address: $(".address").val(),
      city: $(".city").val(),
      country: $(".country").val(),
      email_address: $(".email_address").val(),
      mobile_number: $(".mobile_number").val()
    };
    $(".creatingCustomer").hide();
    $(".creatingCustomerLoader").show();
    baseurl.post(rt.newCustomers, customerDetails).then(res => {
      $(".creatingCustomer").show();
      $(".creatingCustomerLoader").hide();
      $(".form-control").val("");

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.customerCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //customer exits code
        ers.CustomerExists();
      } else if (res.data.code === 404) {
        //error on creating customers
        ers.errorCreatingCustomer();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  loadCustomer({ commit }) {
    baseurl.get(rt.loadCustomers).then(res => {
      $(".customersLoader").hide();

      //checking response codes from backend api
      
      
      if (res.data.code === 200) {
        //success code and committing
        commit("STORE_CUSTOMERS", res.data.customers);
      } else if (res.data.code === 404) {
        //error on loading customers records
        ers.errorLoadingCustomers();
      } else if (res.data.code === 405) {
        //no permission to read code
        commit("STORE_CUSTOMERS", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewCustomer({ commit }, customerId) {
    commit("STORE_CUSTOMER_UPDATE", customerId);
    router.push("/updatecustomer");
  },
  fileCustomer({ commit }, customerId) {
    commit("STORE_CUSTOMER_UPDATE", customerId);
    router.push("/newfile");
  },

  customerUpdate({ commit }) {
    let customerDetails = {
      id: $(".id").val(),
      customer_name: $(".customer_name").val(),
      address: $(".address").val(),
      city: $(".city").val(),
      country: $(".country").val(),
      email_address: $(".email_address").val(),
      mobile_number: $(".mobile_number").val()
    };
    $(".updatingCustomer").hide();
    $(".updatingCustomerLoader").show();
    baseurl.post(rt.updateCustomers, customerDetails).then(res => {
      $(".updatingCustomer").show();
      $(".updatingCustomerLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.customerUpdateSuccess();
        commit("STORE_CUSTOMERS", res.data.customers);
        setTimeout(() => {
          router.push("/managecustomers");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating customer record
        ers.errorUpdatingCustomer();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/customers/actions.js